import { IOC_TYPES } from '../../../xdr/groupAttributionIocSidePanel/types';

export enum IntelliZoneRoutes {
  THREAT_SEARCH = '/threat-search/cumulative-browse?query='
}

export const IOC_POSSIBLE_TYPES_FOR_IZ: IOC_TYPES[] = [
  IOC_TYPES.MD5,
  IOC_TYPES.SHA256,
  IOC_TYPES.URL,
  IOC_TYPES.IP,
  IOC_TYPES.DOMAIN
]

type IntelliZoneFilter = 'actor_name' |
  'min_confidence' |
  'indicator'

export type IntelliZoneQuery = {
  [key in IntelliZoneFilter]?: string | number;
}

export interface IntelliZoneIntegrationData {
  hasAccessToIZProductTrial: boolean;
  canPivotToIntelliZone: boolean;
  intellizoneUrl: string;
}
